export default __webpack_public_path__ + "static/media/trr-food-pastry-14.9e4f50af.png";